export const piechartOptions = {
  colors: ['#0d81f5', '#7fbbf7'],
  backgroundColor: {
    fill: 'transparent',
  },
  chartArea: { right: 0, left: 30, top: 0, bottom: 15, width: '100%', height: '100%' },
  enableInteractivity: false,
  fontName: 'Arial',
  fontSize: 14,
  legend: {
    alignment: 'end',
    position: 'left',
    textStyle: {
      color: '#909399',
      fontName: 'Arial',
      fontSize: 16,
      bold: false,
      italic: false,
    },
  },
};

export const treeMapOptions = {
  width: 280,
  height: 200,
  headerHeight: 0,
  headerHighlightColor: 'transparent',
  minColor: '#7fbbf7',
  midColor: '#3d99f5',
  maxColor: '#0d81f5',
  fontColor: 'white',
  showScale: false,
  eventsConfig: {
    highlight: [],
    unhighlight: [],
    rollup: [],
    drilldown: [],
  },
  showTooltips: true,
  textStyle: {
    color: 'white',
    fontName: 'Arial',
    fontSize: 14,
    bold: false,
    italic: false,
  },
};

export const treeMapSettings = {
  packages: ['treemap'],
};
